import { useState, useEffect } from 'react';
import { XMarkIcon, ArrowUpOnSquareIcon } from '@heroicons/react/24/outline';
import PropTypes from 'prop-types';

const PWAInstallGuide = ({ isVisible, onClose, orgName, orgLogo }) => {
	console.log('PWAInstallGuide visible', isVisible);
	const [isIOS, setIsIOS] = useState(false);
	const [isAndroid, setIsAndroid] = useState(false);

	useEffect(() => {
		const userAgent = navigator.userAgent || window.opera;
		setIsIOS(/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream);
		setIsAndroid(/android/i.test(userAgent));
	}, []);

	const getInstructions = () => {
		if (isIOS) {
			return (
				<div className="space-y-3">
					<p className="text-sm text-gray-600">
						Tap the <ArrowUpOnSquareIcon className="w-4 h-4 inline mx-1" />{' '}
						share button below, then select{' '}
						<span className="font-semibold">
							&quot;Add to Home Screen&quot;
						</span>
					</p>
				</div>
			);
		} else if (isAndroid) {
			return (
				<div className="space-y-3">
					<p className="text-sm text-gray-600">
						Tap the menu button (⋮) in your browser, then select{' '}
						<span className="font-semibold">
							&quot;Add to Home screen&quot;
						</span>{' '}
						or <span className="font-semibold">&quot;Install app&quot;</span>
					</p>
				</div>
			);
		} else {
			return (
				<div className="space-y-3">
					<p className="text-sm text-gray-600">
						Use your browser&apos;s menu to{' '}
						<span className="font-semibold">
							&quot;Add to Home Screen&quot;
						</span>{' '}
						or <span className="font-semibold">&quot;Install&quot;</span> this
						app.
					</p>
				</div>
			);
		}
	};

	if (!isVisible) return null;

	return (
		<>
			{/* Backdrop */}
			<div
				className="fixed inset-0 bg-black bg-opacity-50 z-50 transition-opacity duration-300"
				onClick={onClose}
			/>

			{/* Modal */}
			<div className="fixed inset-x-0 bottom-0 z-50 pwa-install-guide">
				<div className="bg-white rounded-t-2xl shadow-xl border-t border-gray-200">
					{/* Header */}
					<div className="flex items-center justify-between px-6 py-4 border-b border-gray-200">
						<div className="flex items-center space-x-3">
							<div className="w-10 h-10 bg-gray-900 rounded-lg flex items-center justify-center">
								<img
									src={orgLogo || '/connected-logo.png'}
									alt="App Logo"
									className="w-6 h-6"
									onError={(e) => {
										e.target.style.display = 'none';
									}}
								/>
							</div>
							<div>
								<h3 className="text-lg font-semibold text-gray-900">
									Install {orgName || 'Connect Platform'}
								</h3>
								<p className="text-sm text-gray-500">
									Get the full app experience
								</p>
							</div>
						</div>
						<button
							onClick={onClose}
							className="p-2 hover:bg-gray-100 rounded-full transition-colors"
						>
							<XMarkIcon className="w-5 h-5 text-gray-400" />
						</button>
					</div>

					{/* Content */}
					<div className="px-6 py-4">{getInstructions()}</div>

					{/* Safe area padding for iPhone */}
					<div className="pb-safe" />
				</div>
			</div>
		</>
	);
};

PWAInstallGuide.propTypes = {
	isVisible: PropTypes.bool.isRequired,
	onClose: PropTypes.func.isRequired,
	orgName: PropTypes.string,
	orgLogo: PropTypes.string,
};

export default PWAInstallGuide;
